(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bmsm"] && !Shopify.designMode) return;
  try {
    class BmsmSelector extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.sectionId = this.dataset.sectionId;
    this.swatches = Array.from(this.querySelectorAll('.bmsm__swatch'));
    this.qtySelect = this.querySelector('[data-bmsm-qty]');
    this.quantityInput = this.querySelector('[data-bmsm-quantity-input]');
    this.activeSwatch = this.querySelector('.bmsm__swatch.is-active') || this.swatches[0];
    this.abortController = null;

    this.swatches.forEach((s) => {
      s.addEventListener('click', (e) => {
        if (e.target.closest('[data-bmsm-qty-wrap]')) return;
        this.select(s);
      });
    });
    if (this.qtySelect) {
      this.qtySelect.addEventListener('change', () => this.onQtyChange());
    }
    if (this.qtySelect?.disabled) this.setSubmitDisabled(true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this._optionChangeUnsub = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.closest('product-info')?.contains(data.event.target)) this.abortController?.abort();
      });
      this._variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.sectionId) return;
        if (this.activeSwatch?.dataset.mode === 'bundle') {
          this.fetchAndApply(this.activeSwatch);
        } else {
          this.updateQuantity(data.html);
        }
      });
      this._cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (this.activeSwatch?.dataset.mode === 'single') return this.fetchAndApply(this.activeSwatch);
      });
    }
  }

  disconnectedCallback() {
    if (this._variantChangeUnsub) this._variantChangeUnsub();
    if (this._optionChangeUnsub) this._optionChangeUnsub();
    if (this._cartUpdateUnsub) this._cartUpdateUnsub();
    if (this.abortController) this.abortController.abort();
  }

  updateQuantity(doc) {
    const source = doc.querySelector(`bmsm-selector[data-form-id="${this.formId}"] [data-bmsm-qty]`);
    if (!source || !this.qtySelect) return;
    const previous = Number(this.qtySelect.value);
    this.qtySelect.innerHTML = source.innerHTML;
    this.qtySelect.disabled = source.disabled;
    // Preserve the selection when valid, otherwise choose the nearest lower option.
    const options = Array.from(this.qtySelect.options);
    const selected = options.filter((option) => Number(option.value) <= previous).pop() || options[0];
    this.qtySelect.value = selected?.value || '0';
    if (this.quantityInput) this.quantityInput.value = this.qtySelect.value;
    if (this.qtySelect.disabled) this.setSubmitDisabled(true);
  }

  // Mirror the variant-selects selection (single's dropdown) so we can ask
  // the target product to render the matching variant.
  currentVariantTitle() {
    const vs =
      document.querySelector('variant-selects') ||
      document.querySelector('variant-radios');
    if (!vs) return null;
    const parts = [];
    vs.querySelectorAll('select').forEach((sel) => parts.push(sel.value));
    vs.querySelectorAll(
      'input[type="radio"]:checked, fieldset input:checked'
    ).forEach((r) => parts.push(r.value));
    const seen = parts.filter((p) => p != null && p !== '');
    return seen.length ? seen.join(' / ') : null;
  }

  // Returns the option_value_ids array (option-position-ordered) for the
  // swatch's target product, picking the values that match the current
  // variant title.
  optionValueIdsFor(swatch) {
    let map = {};
    try {
      map = JSON.parse(swatch.dataset.optionsMap || '{}');
    } catch (e) {
      map = {};
    }
    const title = this.currentVariantTitle();
    if (!title) return [];
    return title
      .split(' / ')
      .map((part) => part.trim())
      .map((part) => (map[part] != null ? String(map[part]) : null))
      .filter(Boolean);
  }

  getProductForm() {
    return document.getElementById(this.formId);
  }

  getProductFormElement() {
    const f = this.getProductForm();
    return f ? f.closest('product-form') : null;
  }

  setSubmitDisabled(disabled, label) {
    const pf = this.getProductFormElement();
    if (pf && typeof pf.toggleSubmitButton === 'function') {
      // Only pass the label when a sold-out string is explicitly wanted — passing
      // it on every disable (e.g. mid-fetch) would flash "Sold out" before the
      // response comes back. Mid-fetch we call with no label so the current
      // "Add to cart" text stays put.
      if (label) {
        pf.toggleSubmitButton(disabled, label);
      } else {
        pf.toggleSubmitButton(disabled);
      }
      return;
    }
    // Fallback if product-form custom element isn't around: toggle directly.
    const btn = document.getElementById('ProductSubmitButton-' + this.sectionId);
    if (!btn) return;
    if (disabled) {
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.removeAttribute('disabled');
    }
  }

  select(swatch) {
    if (swatch === this.activeSwatch) return;
    this.swatches.forEach((s) => {
      const active = s === swatch;
      s.classList.toggle('is-active', active);
      // Apply Dawn's `color-scheme-2 gradient` classes only to the active
      // swatch so its grey background pulls from the theme's scheme-2
      // colour scheme instead of being hardcoded.
      s.classList.toggle('color-scheme-2', active);
      s.classList.toggle('gradient', active);
      s.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    this.activeSwatch = swatch;
    if (swatch.dataset.mode === 'bundle') {
      if (this.qtySelect) this.qtySelect.selectedIndex = 0;
    }
    if (this.quantityInput) this.quantityInput.value = '1';
    this.fetchAndApply(swatch);
  }

  onQtyChange() {
    if (this.qtySelect.disabled || this.activeSwatch?.dataset.mode !== 'single') return;
    const q = parseInt(this.qtySelect.value, 10) || 1;
    const match = this.swatches.find(
      (s) =>
        s.dataset.mode === 'bundle' &&
        parseInt(s.dataset.packCount, 10) === q
    );
    if (match) {
      this.select(match);
    } else if (this.quantityInput) {
      this.quantityInput.value = this.qtySelect.value || '1';
    }
  }

  // Mirrors what Dawn does on a variant change, but pointed at the BMSM
  // swatch's target product, and only updating the form buttons + variant
  // dropdown selection + price block + stock block. Everything else on the
  // page stays attached to the original (single) product.
  fetchAndApply(swatch) {
    if (!swatch || !this.sectionId) return;
    const url = swatch.dataset.productUrl;
    if (!url) return;

    const params = ['section_id=' + encodeURIComponent(this.sectionId)];
    const ids = this.optionValueIdsFor(swatch);
    if (ids.length) params.push('option_values=' + ids.map(encodeURIComponent).join(','));
    const requestUrl = url + '?' + params.join('&');

    this.setSubmitDisabled(true);

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    return fetch(requestUrl, { signal })
      .then((r) => {
        if (!r.ok) throw new Error(`Section request failed: ${r.status}`);
        return r.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        this.applyFromDoc(doc);
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        console.error('[BMSM] section fetch failed', err);
      });
  }

  applyFromDoc(doc) {
    const sid = this.sectionId;

    // 1. Price block — innerHTML swap on #price-{section_id}.
    const srcPrice = doc.getElementById('price-' + sid);
    const dstPrice = document.getElementById('price-' + sid);
    if (srcPrice && dstPrice) {
      dstPrice.innerHTML = srcPrice.innerHTML;
      dstPrice.classList.toggle('hidden', srcPrice.classList.contains('hidden'));
      const saleBadge = dstPrice.querySelector('.price__badge-sale');
      if (saleBadge) saleBadge.remove();
      const priceDiv = dstPrice.querySelector('.price');
      if (priceDiv) priceDiv.classList.remove('price--show-badge');
    }

    // 2. Stock block — outerHTML swap on .pdp-stock (preserves the block
    //    wrapper's shopify_attributes from the fetched markup).
    const srcStock = doc.querySelector('.pdp-stock');
    const dstStock = document.querySelector('.pdp-stock');
    if (srcStock && dstStock) {
      dstStock.replaceWith(srcStock.cloneNode(true));
    }

    // 3. Form id input(s) — main add-to-cart form and installment form.
    //    For the installment form we also fire `input` + `change` events so
    //    Shopify's `<shopify-payment-terms>` web component re-fetches the
    //    "Pay in 4" copy + amount for the new variant. Plain `.value = x`
    //    assignment doesn't trigger that listener on its own.
    [
      'product-form-' + sid,
      'product-form-installment-' + sid,
    ].forEach((id) => {
      const srcForm = doc.getElementById(id);
      const dstForm = document.getElementById(id);
      if (!srcForm || !dstForm) return;
      const srcId = srcForm.querySelector('input[name="id"]');
      const dstId = dstForm.querySelector('input[name="id"]');
      if (srcId && dstId && dstId.value !== srcId.value) {
        dstId.value = srcId.value;
        dstId.dispatchEvent(new Event('input', { bubbles: true }));
        dstId.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 3b. Replace the rendered <shopify-payment-terms> element wholesale
    //     using the markup from the fetched bundle product page — covers the
    //     case where the component only binds on initial render and ignores
    //     subsequent value changes on the hidden input. Swap is keyed to the
    //     installment form so we don't disturb the main product form.
    const installmentFormId = 'product-form-installment-' + sid;
    const srcTerms = doc.querySelector('#' + CSS.escape(installmentFormId) + ' shopify-payment-terms');
    const dstTerms = document.querySelector('#' + CSS.escape(installmentFormId) + ' shopify-payment-terms');
    if (srcTerms && dstTerms) {
      dstTerms.replaceWith(srcTerms.cloneNode(true));
    }

    // 4. Style dropdown — keep the SINGLE product's dropdown structure (so
    //    user changes still flow through Dawn for this product), but mirror
    //    the source's selected option onto the local dropdown so the
    //    displayed selection matches what we just applied. We do NOT replace
    //    the dropdown itself — that would re-target it at the bundle product
    //    and break subsequent variant changes.
    const srcVs = doc.querySelector('variant-selects');
    const dstVs = document.querySelector('variant-selects');
    if (srcVs && dstVs) {
      const srcSelects = srcVs.querySelectorAll('select');
      const dstSelects = dstVs.querySelectorAll('select');
      srcSelects.forEach((srcSel, i) => {
        const dstSel = dstSelects[i];
        if (dstSel && srcSel.value && dstSel.value !== srcSel.value) {
          dstSel.value = srcSel.value;
        }
      });
    }

    // 5. Submit button enabled/disabled state — Dawn reads this from the
    //    response's ProductSubmitButton-{section_id} disabled attribute. Only
    //    pass the sold-out label when the response is actually disabled, so
    //    re-enabling falls back to product-form's own "Add to cart" reset.
    const srcBtn = doc.getElementById('ProductSubmitButton-' + sid);
    const isDisabled = srcBtn ? srcBtn.hasAttribute('disabled') : false;
    this.setSubmitDisabled(isDisabled, isDisabled ? (window.variantStrings && window.variantStrings.soldOut) : null);
    if (this.activeSwatch?.dataset.mode === 'single') this.updateQuantity(doc);
  }
}

if (!customElements.get('bmsm-selector')) {
  customElements.define('bmsm-selector', BmsmSelector);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-key-value-props"] && !Shopify.designMode) return;
  try {
    (function () {
  function uniquifyIcons() {
    document.querySelectorAll('.kv-props').forEach(function (root) {
      if (root.dataset.iconsScoped === 'true') return;
      root.dataset.iconsScoped = 'true';
      root.querySelectorAll('svg').forEach(function (svg, index) {
        var html = svg.outerHTML;
        var matches = html.match(/id="([^"]+)"/g);
        if (!matches) return;
        matches.forEach(function (token) {
          var id = token.slice(4, -1);
          var newId = id + '__kv' + index;
          html = html.split('#' + id).join('#' + newId);
          html = html.split('id="' + id + '"').join('id="' + newId + '"');
        });
        svg.outerHTML = html;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', uniquifyIcons);
  } else {
    uniquifyIcons();
  }
  document.addEventListener('shopify:section:load', uniquifyIcons);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.formId = this.dataset.formId;
    this.priceSlot = this.querySelector('[data-sticky-atc-price]');
    this.subtitleSlot = this.querySelector('[data-sticky-atc-subtitle]');
    this.ctas = Array.from(this.querySelectorAll('[data-sticky-atc-cta]'));
    this.ctaLabels = Array.from(this.querySelectorAll('[data-sticky-atc-cta-label]'));

    this.removeAttribute('hidden');

    // Run an initial sync of subtitle, price, and CTA state so the bar's
    // contents match what's already on the page before the user scrolls.
    this.syncPrice();
    this.syncSubtitle();
    this.syncCta();

    this.setupVisibilityObservers();
    this.setupMirrorObservers();
    this.setupChangeListeners();
  }

  disconnectedCallback() {
    if (this._scrollHandler) {
      window.removeEventListener('scroll', this._scrollHandler);
      window.removeEventListener('resize', this._scrollHandler);
    }
    this._priceObserver?.disconnect();
    this._ctaObserver?.disconnect();
    if (this._variantChangeUnsub) this._variantChangeUnsub();
    if (this._docChangeHandler) document.removeEventListener('change', this._docChangeHandler, true);
    if (this._docClickHandler) document.removeEventListener('click', this._docClickHandler, true);
  }

  // ----- Visibility (scroll triggers) -----
  //
  // Show the bar once the main ATC has scrolled out of view above the
  // viewport, hide it when the footer scrolls in. Implemented as a
  // requestAnimationFrame-throttled scroll handler reading bounding
  // rects directly — simpler and more reliable across environments
  // than IntersectionObserver for this particular case.

  setupVisibilityObservers() {
    // updateVisibility() is two getBoundingClientRect() reads + a classList
    // toggle — cheap enough to run on every scroll/resize without throttling.
    this._scrollHandler = () => this.updateVisibility();
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
    window.addEventListener('resize', this._scrollHandler, { passive: true });
    // Run once on mount so the initial state is correct.
    this.updateVisibility();
  }

  updateVisibility() {
    // Keep the desktop bar pinned directly under whatever Dawn-style
    // sticky header is currently at the top of the viewport. Read the
    // header's bottom edge live (it can change as the announcement bar
    // scrolls away).
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header.header');
    let headerBottom = 0;
    if (header) {
      const hr = header.getBoundingClientRect();
      // Only treat the header as occupying space at the top if its bottom
      // edge is at or below the viewport top — otherwise it's been
      // scrolled away (e.g. announcement bar).
      if (hr.bottom > 0) headerBottom = Math.max(0, hr.bottom);
    }
    this.style.setProperty('--sticky-atc-top', headerBottom + 'px');

    const mainCta = document.getElementById('ProductSubmitButton-' + this.sectionId);
    if (!mainCta) {
      this.classList.remove('is-visible');
      return;
    }
    const ctaRect = mainCta.getBoundingClientRect();
    // Main ATC has fully scrolled above the sticky header once its bottom
    // edge is at or above the header's bottom — that's the point at which
    // the user can no longer see the main ATC.
    const scrolledPast = ctaRect.bottom <= headerBottom;

    // Hide the bar only when the page footer has actually reached the user
    // — i.e. its top has crossed about halfway up the viewport. Using the
    // strict "any part visible" rule hides the bar on short pages where
    // the footer touches the bottom of the viewport long before the user
    // is anywhere near it.
    const footer = document.querySelector('.site-footer, footer.footer, footer[role="contentinfo"], footer');
    let footerReached = false;
    if (footer) {
      const fRect = footer.getBoundingClientRect();
      footerReached = fRect.top < window.innerHeight * 0.5;
    }

    const isVisible = scrolledPast && !footerReached;
    this.classList.toggle('is-visible', isVisible);
    const bar = this.querySelector('.sticky-atc__bar--desktop');
    document.documentElement.style.setProperty(
      '--sticky-atc-height',
      isVisible && bar ? bar.offsetHeight + 'px' : '0px'
    );
  }

  // ----- Mirroring main section state (price + cta disabled/label) -----

  setupMirrorObservers() {
    const priceEl = document.getElementById('price-' + this.sectionId);
    if (priceEl && 'MutationObserver' in window) {
      this._priceObserver = new MutationObserver(() => this.syncPrice());
      this._priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }

    const mainCta = document.getElementById('ProductSubmitButton-' + this.sectionId);
    if (mainCta && 'MutationObserver' in window) {
      this._ctaObserver = new MutationObserver(() => this.syncCta());
      // Watch class too so we can mirror the .loading state Dawn's product-form
      // toggles during the add-to-cart fetch.
      this._ctaObserver.observe(mainCta, {
        attributes: true,
        attributeFilter: ['disabled', 'class'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  syncPrice() {
    const priceEl = document.getElementById('price-' + this.sectionId);
    if (!priceEl || !this.priceSlot) return;
    this.priceSlot.innerHTML = priceEl.innerHTML;
  }

  syncCta() {
    const mainCta = document.getElementById('ProductSubmitButton-' + this.sectionId);
    if (!mainCta) return;
    const disabled = mainCta.hasAttribute('disabled');
    const loading = mainCta.classList.contains('loading');
    const labelEl = mainCta.querySelector('span');
    const label = (labelEl ? labelEl.textContent : mainCta.textContent || '').trim();
    this.ctas.forEach((cta) => {
      if (disabled) {
        cta.setAttribute('disabled', 'disabled');
      } else {
        cta.removeAttribute('disabled');
      }
      // Mirror Dawn's loading class so each sticky button shows the same
      // spinner + hides its label while the add-to-cart fetch is in flight.
      cta.classList.toggle('loading', loading);
      const spinner = cta.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    });
    if (label) {
      this.ctaLabels.forEach((el) => {
        el.textContent = label;
      });
    }
  }

  // ----- Subtitle (variant title + BMSM label) -----

  setupChangeListeners() {
    // Re-derive the subtitle on:
    //  - any variant-selects change (dropdown or radio),
    //  - any BMSM swatch click,
    //  - Dawn's variantChange pub/sub (catches the post-fetch settle).
    this._docChangeHandler = (e) => {
      const t = e.target;
      if (t && t.closest && t.closest('variant-selects, variant-radios')) {
        this.syncSubtitle();
      }
    };
    this._docClickHandler = (e) => {
      const t = e.target;
      if (t && t.closest && t.closest('.bmsm__swatch')) {
        // Defer one tick so the swatch's is-active class has flipped.
        setTimeout(() => this.syncSubtitle(), 0);
      }
    };
    document.addEventListener('change', this._docChangeHandler, true);
    document.addEventListener('click', this._docClickHandler, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this._variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        this.syncSubtitle();
      });
    }
  }

  currentVariantTitle() {
    const vs =
      document.querySelector('variant-selects') ||
      document.querySelector('variant-radios');
    if (!vs) return null;
    const parts = [];
    vs.querySelectorAll('select').forEach((sel) => parts.push(sel.value));
    vs.querySelectorAll('input[type="radio"]:checked, fieldset input:checked').forEach((r) =>
      parts.push(r.value)
    );
    const seen = parts.filter((p) => p != null && p !== '');
    return seen.length ? seen.join(' / ') : null;
  }

  currentBmsmLabel() {
    const active = document.querySelector('bmsm-selector .bmsm__swatch.is-active');
    if (!active) return null;
    const name = active.querySelector('.bmsm__name');
    return name ? (name.textContent || '').trim() : null;
  }

  syncSubtitle() {
    if (!this.subtitleSlot) return;
    const variantTitle = this.currentVariantTitle();
    const bmsmLabel = this.currentBmsmLabel();
    const parts = [];
    if (variantTitle) parts.push(variantTitle);
    if (bmsmLabel) parts.push(bmsmLabel);
    this.subtitleSlot.textContent = parts.join(' / ');
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
  } catch(e) { console.error(e); }
})();

})();
